import { render, staticRenderFns } from "./CardRoleSkillEditComponent.vue?vue&type=template&id=2cbf0ca2&scoped=true"
import script from "./CardRoleSkillEditComponent.vue?vue&type=script&lang=js"
export * from "./CardRoleSkillEditComponent.vue?vue&type=script&lang=js"
import style0 from "./CardRoleSkillEditComponent.vue?vue&type=style&index=0&id=2cbf0ca2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf0ca2",
  null
  
)

export default component.exports